<template>
  <div class="">
    <div class="mb-6">
      <b-message type="is-primary">
        {{ $t("demoTranslatorExplained") }}
      </b-message>
    </div>
    <b-field :label="$t('floorLang')" class="mt-3" />
    <b-message type="is-primary">
      {{ $t("demoFloorExplained") }}
    </b-message>
    <LanguagePicker
      v-model="floorLang"
      :whitelist="demoWhitelist"
      :blacklist="[targetLang, relaisLang]"
      :change-local="false"
      :loading="isLoading"
      :disabled="isDisabled"
    />

    <b-field :label="$t('targetLang')" class="mt-3" />
    <b-message type="is-primary">
      {{ $t("demoTargetExplained") }}
    </b-message>
    <LanguagePicker
      v-model="targetLang"
      :whitelist="demoWhitelist"
      :blacklist="[floorLang, relaisLang]"
      :change-local="false"
      :loading="isLoading"
      :disabled="isDisabled"
    />

    <b-field :label="$t('relaisLang')" class="mt-3" />
    <b-message type="is-primary">
      {{ $t("demoRelaisExplained") }}
    </b-message>
    <LanguagePicker
      v-model="relaisLang"
      :whitelist="demoWhitelist"
      :blacklist="[targetLang]"
      :change-local="false"
      :loading="isLoading"
      :disabled="isDisabled"
    />
    <div>
      <b-field>
        <b-button class="mt-4" type="is-primary" :disabled="!valid" @click="launchDemo">
          {{ $t("launchDemo") }}
        </b-button>
      </b-field>
    </div>
  </div>
</template>

<script>
import LanguagePicker from "@/components/LanguagePicker";
import { BASE_URL } from "@/env";
import { functions } from "@/firebase";

export default {
  name: "TranslatorDemos",
  components: {
    LanguagePicker,
  },
  props: {
    translator: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      floorLang: null,
      targetLang: null,
      relaisLang: null,

      demoWhitelist: ["deu", "eng", "spa", "ita", "por"],
      isDisabled: false,
      isLoading: false,
    };
  },
  computed: {
    valid() {
      return this.floorLang && this.targetLang;
    },
  },
  methods: {
    async launchDemo() {
      this.isDisabled = true;
      this.isLoading = true;
      try {
        let speaker = [this.$t("speaker"), this.floorLang];
        let partner = [this.$t("partner"), [this.floorLang, this.targetLang]];

        let demoJSON;
        let langCombs = [[this.floorLang, this.targetLang]];

        if (this.relaisLang) {
          langCombs.push([this.relaisLang, this.targetLang]);
          let relaisTrans = [this.$t("translator") + " " + this.relaisLang, [this.floorLang, this.relaisLang]];
          demoJSON = encodeURIComponent(JSON.stringify([speaker, partner, relaisTrans]));
        } else {
          demoJSON = encodeURIComponent(JSON.stringify([speaker, partner]));
        }

        let response = await functions.httpsCallable("CreateTranslatorDemoEvent")({ langCombs: langCombs });

        let link = `${BASE_URL}/event/${response.data.organizationId}/${response.data.eventId}/${response.data.encryptionPw}/${response.data.eventPw}/?interpreter&demo=${demoJSON}`;
        window.open(link);
      } catch (_error) {
        console.log(1);
      } finally {
        this.isLoading = false;
        this.isDisabled = false;
      }
    },
  },
};
</script>

<style></style>
